import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen app-shell-bg flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          <div className="w-16 h-16 border-4 border-saffron-200 border-t-saffron-600 rounded-full animate-spin mx-auto mb-4"></div>
          <div className="absolute inset-0 w-16 h-16 border-4 border-transparent border-r-saffron-400 rounded-full animate-spin mx-auto" style={{animationDirection: 'reverse', animationDuration: '1.5s'}}></div>
        </div>
        <p className="text-saffron-600 font-medium">Loading your cosmic insights...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
